import http from '@/http'

const URL = '/admin/tickets'

export const getTickets = (params) => http.get(URL, { params })

export const getTicket = (id) => http.get(`${URL}/${id}`)

export const createTicket = (data) => http.post(URL, data)

export const updateTicket = (id, data) => http.put(`${URL}/${id}`, data)

export const toggleTicketStatus = (id) => http.put(`${URL}/${id}/status`)

export const deleteTicket = (id) => http.delete(`${URL}/${id}`)
